import { useParams } from 'react-router-dom';

import { useOrderDetail } from 'hooks';

import { AccordionCard } from './Accordion';
import { AccordionSkeleton } from './Accordion.skeleton';
import Styles from './ItemsAccordion.styles';

export const ItemsAccordion = () => {
  const { id = '0' } = useParams<{ id: string }>();
  const { data: order, isLoading } = useOrderDetail(id);

  const standardList = order?.orderItems?.standard || [];
  const giftList = order?.orderItems?.gift || [];

  if (isLoading) {
    return <AccordionSkeleton />;
  }

  return (
    <Styles.Wrapper direction='column' gap='$4'>
      {Boolean(standardList.length) && <AccordionCard type='standard' items={standardList} />}
      {Boolean(giftList.length) && <AccordionCard type='gift' items={giftList} />}
    </Styles.Wrapper>
  );
};
